var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-8/12 pr-6"},[_c('div',{staticClass:"h-48 hlg:h-56 rounded-xl w-full p-5 flex items-end",style:(_vm.backgroundImage)},[_c('span',{staticClass:"font-bold text-white text-xl mb-3"},[_vm._v("Some title here")])])])}
var staticRenderFns = []

export { render, staticRenderFns }